import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { ImmutableInstitution as InstitutionPropType } from '../../../CustomPropTypes/InstitutionPropTypes';
import { fetchInstitutionRoles } from '../../../ReduxStorage/Institutions/dispatchers';
import {
  validateCourseName,
  validateCourseUrl,
} from '../../../ReduxStorage/Courses/dispatchers.common';
import { selectCreateCourseAllowedInstitutions } from '../../../ReduxStorage/Institutions/selectors';
import { CreateCourseForm } from './component';

class _CreateCourseForm extends React.PureComponent {
  static propTypes = {
    institutions: ImmutablePropTypes.listOf(InstitutionPropType).isRequired,
    getInstitutionRoles: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { getInstitutionRoles } = this.props;
    getInstitutionRoles();
  }

  render() {
    return <CreateCourseForm {...this.props} />;
  }
}

function mapStateToProps(state) {
  return {
    institutions: selectCreateCourseAllowedInstitutions(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getInstitutionRoles: () => dispatch(fetchInstitutionRoles()),
    validateCourseNameChange: (courseName, requestId) =>
      dispatch(validateCourseName(courseName, requestId)),
    validateCoursePathChange: (coursePath, institution, requestId) =>
      dispatch(validateCourseUrl(coursePath, institution, requestId)),
  };
}

export const ConnectedCreateCourseForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(_CreateCourseForm);
